module.exports = __webpack_public_path__ + "static/media/bg_khai02.32619c2f.png";